import { call, put, takeLatest } from 'redux-saga/effects';
import { 
    OVERVIEW_DATA_REQUEST
} from '@src/middleware/actions/actionTypes';
import { setRequestError, setRequestLoading, setRequestSuccess } from '@src/middleware/actions/common/common.actions';
import { overviewStateKeys } from '@src/CommonComponents/constant/constant';

// Mock service - replace with actual service
const getOverviewData = async (payload: any) => {
  // Mock data - replace with actual API call
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        Data: {
          insights: [
            { id: 1, title: 'Sample Overview 1', value: 100 },
            { id: 2, title: 'Sample Overview 2', value: 200 },
          ],
          timePeriod: '01/01/2024 - 12/31/2024'
        },
        status: true
      });
    }, 1000);
  });
};

const getServiceMethod = (key: string) => {
  switch (key) {
    case overviewStateKeys.overviewData:
      return getOverviewData;
    default:
      return getOverviewData;
  }
}

export function* fetchOverviewData(action: any) {
  const { key, payload } = action;
  const loadingKey = `${key}Loading`;
  const errorKey = `${key}Error`;

  try {
    yield put(setRequestError(false, errorKey));
    yield put(setRequestLoading(true, loadingKey));

    const response = yield call(getServiceMethod(key), payload);
    
    yield put(setRequestLoading(false, loadingKey));

    if (response?.status === false) {
      yield put(setRequestError(true, errorKey));
    } else {
      yield put(setRequestSuccess(response?.Data, key));
    }
  } catch (error) {
    yield put(setRequestLoading(false, loadingKey));
    yield put(setRequestError(true, errorKey));
  }
}

export function* overviewSaga() {
  yield takeLatest(OVERVIEW_DATA_REQUEST, fetchOverviewData);
}

export default [overviewSaga];